import { ChartItemType } from "types/report/ReportTypes";

const DEFAULT_CHART: ChartItemType = {
  objectType: "chart",
  objectId: "",
  chartType: "clustered-column",
  orderNum: 0,
  chartTitle: "New Chart",
  slideId: "",
  width: 500,
  height: 500,
  widthOption: "fixed",
  heightOption: "fixed",
  x: 0,
  y: 0,
  rotation: 0,
  isLock: false,
  isHide: false,
  style: {
    chart: JSON.stringify({
      backgroundColor: "",
      strokeType: "",
      strokeWidth: "",
      stroke: "",
      strokePosition: "",
    }),
    legend: JSON.stringify({ position: "top" }),
    chartTitle: "",
    valuesTitle: "",
    labelsTitle: "",
    labelsAxis: "",
    valuesAxis: "",
  },
  option: {
    labels: [],
    values: [],
    tooltip: [],
  },
  dataset: null,
  filter: null,
  format: {
    container: {},
    contents: {},
  },
};
const FIELD_AGGREGATE_TYPE = [
  { label: "ARRAY", value: "array" },
  { label: "AVERAGE", value: "average" },
  { label: "COUNT", value: "count" },
  { label: "COUNT(Numbers Only)", value: "countNumbersOnly" },
  { label: "COUNT(Distinct)", value: "countDistinct" },
  { label: "FIRST", value: "first" },
  { label: "LAST", value: "last" },
  { label: "MAX", value: "max" },
  { label: "MIN", value: "min" },
  { label: "MEDIAN", value: "median" },
  { label: "STDV", value: "standardDeviation" },
  {
    label: "STDV(Entire Population)",
    value: "standardDeviationPopulation",
  },
  { label: "SUM", value: "sum" },
  { label: "VARIANCE", value: "variance" },
  {
    label: "VARIANCE(Entire Population)",
    value: "variancePopulation",
  },
];

export default {
  DEFAULT_CHART,
  FIELD_AGGREGATE_TYPE,
};
